// extracted by mini-css-extract-plugin
export default {"root":"Chat_root__fux8p","header":"Chat_header__xZ-Dh"};